/** A quantity that has no receipt of its own says so, and why - `CLAUDE.md` rule 3, G-P7-10.
 *
 * A shown number resolves to a receipt, or states, where it is printed, why it has none. The reasons
 * that are real are few: it is a **count**, a **difference** of two figures that each open their own
 * receipt, a **sum of rows** that are listed beside it with a receipt each, or an **artifact's frozen
 * total** whose provenance is the artifact. Anything else is a missing receipt, not an exemption.
 *
 * Spread the result on the element that holds the number: `data-no-receipt` is what the browser gate's
 * orphan detector and `orphanFigures` (the screen gate) read, and `title` is the reason a reader sees on
 * hover. Nothing is added to the visible text, so the text budget is untouched. A reason must say what
 * the number is made of and where its parts open, never restate the number.
 */

/** The reasons the product uses, one per kind, so the same fact is not worded five ways. */
export const NO_RECEIPT = {
  difference:
    "A change, not a figure: this period's total less the prior period's. The total it is a change in opens its figures.",
  sumOfRows: "The sum of the rows listed below, whole records as stored. Each row opens its own receipt.",
  siteMonth:
    "One site's share of the month. Clear the site filter to open the month's figures, each with its receipt.",
  reportRow:
    "Each row is a sum of figures. Open the figures lists the ones behind this report, each with its receipt.",
  frozenTotal:
    "The total as it will be frozen in the filing's artifact, taken from the Disclosures tab, whose lines each open a receipt.",
} as const;

export function noReceipt(reason: string): { "data-no-receipt": string; title: string } {
  return { "data-no-receipt": reason, title: reason };
}
